// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AdminAddMemberData, AdminAddMemberErrors, AdminAddMemberResponses, AdminAssignRoleData, AdminAssignRoleErrors, AdminAssignRoleResponses, AdminCreateCompanyData, AdminCreateCompanyErrors, AdminCreateCompanyResponses, AdminGetCompanyData, AdminGetCompanyErrors, AdminGetCompanyResponses, AdminGetUserData, AdminGetUserErrors, AdminGetUserResponses, AdminListCompaniesData, AdminListCompaniesErrors, AdminListCompaniesResponses, AdminListInvitesData, AdminListInvitesErrors, AdminListInvitesResponses, AdminListMembersData, AdminListMembersErrors, AdminListMembersResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersResponses, AdminRemoveMemberData, AdminRemoveMemberErrors, AdminRemoveMemberResponses, AdminRevokeInviteData, AdminRevokeInviteErrors, AdminRevokeInviteResponses, AdminRevokeRoleData, AdminRevokeRoleErrors, AdminRevokeRoleResponses, AdminUpdateCompanyData, AdminUpdateCompanyErrors, AdminUpdateCompanyResponses, AdminUpdateUserData, AdminUpdateUserErrors, AdminUpdateUserResponses, AnalyzeDatasetData, AnalyzeDatasetErrors, AnalyzeDatasetResponses, ConfirmPlansActualsImportData, ConfirmPlansActualsImportErrors, ConfirmPlansActualsImportResponses, CreateCompanyInviteData, CreateCompanyInviteErrors, CreateCompanyInviteResponses, CreateCompanyWorkspaceData, CreateCompanyWorkspaceErrors, CreateCompanyWorkspaceResponses, CreateExclusionRuleData, CreateExclusionRuleErrors, CreateExclusionRuleResponses, DeleteDatasetData, DeleteDatasetErrors, DeleteDatasetResponses, DeleteExclusionRuleData, DeleteExclusionRuleErrors, DeleteExclusionRuleResponses, DeletePlansActualsAttachmentData, DeletePlansActualsAttachmentErrors, DeletePlansActualsAttachmentResponses, DeleteWorkspaceData, DeleteWorkspaceErrors, DeleteWorkspaceIntegrationData, DeleteWorkspaceIntegrationErrors, DeleteWorkspaceIntegrationResponses, DeleteWorkspaceResponses, DownloadPlansActualsAttachmentData, DownloadPlansActualsAttachmentErrors, DownloadPlansActualsAttachmentResponses, DownloadPlansActualsImportOriginalData, DownloadPlansActualsImportOriginalErrors, DownloadPlansActualsImportOriginalResponses, ExportDatasetRowsCsvData, ExportDatasetRowsCsvErrors, ExportDatasetRowsCsvResponses, ExportPlansActualsData, ExportPlansActualsErrors, ExportPlansActualsResponses, GetApiV1CompaniesData, GetApiV1CompaniesErrors, GetApiV1CompaniesResponses, GetApiV1ConfigData, GetApiV1ConfigErrors, GetApiV1ConfigResponses, GetApiV1MeData, GetApiV1MeErrors, GetApiV1MeResponses, GetAuthCallbackData, GetAuthCallbackErrors, GetAuthInviteAcceptData, GetAuthInviteAcceptErrors, GetAuthLoginData, GetAuthLoginErrors, GetAuthLogoutData, GetAuthTestData, GetAuthTestErrors, GetAuthTestResponses, GetDatasetData, GetDatasetErrors, GetDatasetResponses, GetOauthProviderCallbackData, GetOauthProviderCallbackErrors, GetOauthProviderStartData, GetOauthProviderStartErrors, GetPlansActualsDatasetData, GetPlansActualsDatasetErrors, GetPlansActualsDatasetResponses, GetPlansActualsReportData, GetPlansActualsReportErrors, GetPlansActualsReportResponses, GetWorkspaceChartData, GetWorkspaceChartErrors, GetWorkspaceChartResponses, GetWorkspaceContextData, GetWorkspaceContextErrors, GetWorkspaceContextResponses, GetWorkspaceData, GetWorkspaceDatasetAccountDealsData, GetWorkspaceDatasetAccountDealsErrors, GetWorkspaceDatasetAccountDealsResponses, GetWorkspaceDatasetAccountPerformanceData, GetWorkspaceDatasetAccountPerformanceErrors, GetWorkspaceDatasetAccountPerformanceResponses, GetWorkspaceDatasetArrSummaryData, GetWorkspaceDatasetArrSummaryErrors, GetWorkspaceDatasetArrSummaryResponses, GetWorkspaceDatasetChartData, GetWorkspaceDatasetChartErrors, GetWorkspaceDatasetChartResponses, GetWorkspaceDatasetTopAccountsData, GetWorkspaceDatasetTopAccountsErrors, GetWorkspaceDatasetTopAccountsResponses, GetWorkspaceErrors, GetWorkspaceIntegrationData, GetWorkspaceIntegrationDealDatePropertiesData, GetWorkspaceIntegrationDealDatePropertiesErrors, GetWorkspaceIntegrationDealDatePropertiesResponses, GetWorkspaceIntegrationErrors, GetWorkspaceIntegrationPipelinesData, GetWorkspaceIntegrationPipelinesErrors, GetWorkspaceIntegrationPipelinesResponses, GetWorkspaceIntegrationResponses, GetWorkspaceResponses, ListCompanyWorkspacesData, ListCompanyWorkspacesErrors, ListCompanyWorkspacesResponses, ListDatasetFlagsData, ListDatasetFlagsErrors, ListDatasetFlagsResponses, ListDatasetRowsData, ListDatasetRowsErrors, ListDatasetRowsResponses, ListDatasetsData, ListDatasetsErrors, ListDatasetsResponses, ListExclusionRulesData, ListExclusionRulesErrors, ListExclusionRulesResponses, ListPlansActualsAttachmentsData, ListPlansActualsAttachmentsErrors, ListPlansActualsAttachmentsResponses, ListPlansActualsDatasetImportsData, ListPlansActualsDatasetImportsErrors, ListPlansActualsDatasetImportsResponses, ListPlansActualsDatasetsData, ListPlansActualsDatasetsErrors, ListPlansActualsDatasetsResponses, PatchApiV1UserDefaultCompanyData, PatchApiV1UserDefaultCompanyErrors, PatchApiV1UserDefaultCompanyResponses, PatchWorkspaceData, PatchWorkspaceErrors, PatchWorkspaceIntegrationData, PatchWorkspaceIntegrationErrors, PatchWorkspaceIntegrationResponses, PatchWorkspaceResponses, PostApiV1ChatStreamData, PostApiV1ChatStreamErrors, PostApiV1ChatStreamResponses, PostWorkspaceIntegrationSyncData, PostWorkspaceIntegrationSyncErrors, PostWorkspaceIntegrationSyncResponses, PreviewPlansActualsImportData, PreviewPlansActualsImportErrors, PreviewPlansActualsImportResponses, UpdatePlansActualsDatasetMetadataData, UpdatePlansActualsDatasetMetadataErrors, UpdatePlansActualsDatasetMetadataResponses, UploadDatasetData, UploadDatasetErrors, UploadDatasetResponses, UploadPlansActualsAttachmentData, UploadPlansActualsAttachmentErrors, UploadPlansActualsAttachmentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Start Auth0 login (browser)
 *
 * Initiates the Auth0 Authorization Code + PKCE flow using identity-only login. The backend uses its configured Auth0 callback URL for the OAuth exchange. Optional `return_to` values are validated so only safe origins (from BACKEND_CORS_ORIGINS) or vetted relative paths are preserved through the callback; unsafe values trigger a 400 error.
 *
 */
export const getAuthLogin = <ThrowOnError extends boolean = false>(options?: Options<GetAuthLoginData, ThrowOnError>) => (options?.client ?? client).get<unknown, GetAuthLoginErrors, ThrowOnError>({ url: '/auth/login', ...options });

/**
 * Accept app-managed invite link
 *
 * Browser-oriented endpoint for invite links. Valid invites redirect to Auth0 authorize. For invalid/expired/revoked/consumed invites, browser requests may redirect to login with an invite error code, while explicit JSON clients can still receive 400/410 `ErrorResponse` payloads.
 *
 */
export const getAuthInviteAccept = <ThrowOnError extends boolean = false>(options: Options<GetAuthInviteAcceptData, ThrowOnError>) => (options.client ?? client).get<unknown, GetAuthInviteAcceptErrors, ThrowOnError>({ url: '/auth/invite/accept', ...options });

/**
 * Auth0 login callback
 */
export const getAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<GetAuthCallbackData, ThrowOnError>) => (options?.client ?? client).get<unknown, GetAuthCallbackErrors, ThrowOnError>({ url: '/auth/callback', ...options });

/**
 * Logout and clear session cookie
 *
 * Clears the stateless session cookie and redirects the browser to Auth0's federated logout endpoint.
 *
 */
export const getAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<GetAuthLogoutData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/auth/logout', ...options });

/**
 * Start OAuth for an integration provider
 */
export const getOauthProviderStart = <ThrowOnError extends boolean = false>(options: Options<GetOauthProviderStartData, ThrowOnError>) => (options.client ?? client).get<unknown, GetOauthProviderStartErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/oauth/{provider}/start',
    ...options
});

/**
 * OAuth callback for an integration provider
 */
export const getOauthProviderCallback = <ThrowOnError extends boolean = false>(options: Options<GetOauthProviderCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, GetOauthProviderCallbackErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/oauth/{provider}/callback',
    ...options
});

/**
 * Get authenticated caller identity and session defaults
 *
 * Returns the authenticated caller's profile, app roles and permissions, and resolved default company/workspace IDs in one response. Default IDs are preserved only when the target company and workspace are active, and the caller either belongs to the company or has `admin.companies.manage`. This is the single identity/bootstrap endpoint for authenticated frontend flows. Cookie-authenticated requests from inactive accounts are rejected by middleware before this handler runs.
 *
 */
export const getApiV1Me = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1MeData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MeResponses, GetApiV1MeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/me',
    ...options
});

/**
 * Get deployment configuration for authenticated clients
 *
 * Returns deployment-level feature configuration exposed to the frontend. Values reflect server runtime configuration and are the same for all callers.
 *
 */
export const getApiV1Config = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ConfigData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ConfigResponses, GetApiV1ConfigErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/config',
    ...options
});

/**
 * Submit a single-turn chatbot query (SSE stream)
 *
 * Accepts a single natural-language query from an authenticated caller and streams chatbot progress and answer tokens as Server-Sent Events. Token events carry plain-text Markdown deltas for transport only; clients should not render them. The final `done` event includes the full sanitized HTML answer converted from the accumulated Markdown (`content_type` `html`). When no answer was produced, `done` uses `content_type` `none` with empty `content`.
 *
 */
export const postApiV1ChatStream = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ChatStreamData, ThrowOnError>) => (options.client ?? client).sse.post<PostApiV1ChatStreamResponses, PostApiV1ChatStreamErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/chat/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Persist the caller's selected default company
 *
 * Persists the caller's selected default company. Callers may select a company they belong to. Callers with `admin.companies.manage` may instead select any active company.
 *
 */
export const patchApiV1UserDefaultCompany = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1UserDefaultCompanyData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1UserDefaultCompanyResponses, PatchApiV1UserDefaultCompanyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/user/default-company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all companies (admin)
 */
export const adminListCompanies = <ThrowOnError extends boolean = false>(options?: Options<AdminListCompaniesData, ThrowOnError>) => (options?.client ?? client).get<AdminListCompaniesResponses, AdminListCompaniesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies',
    ...options
});

/**
 * Create a company (admin)
 */
export const adminCreateCompany = <ThrowOnError extends boolean = false>(options: Options<AdminCreateCompanyData, ThrowOnError>) => (options.client ?? client).post<AdminCreateCompanyResponses, AdminCreateCompanyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get company details (admin)
 */
export const adminGetCompany = <ThrowOnError extends boolean = false>(options: Options<AdminGetCompanyData, ThrowOnError>) => (options.client ?? client).get<AdminGetCompanyResponses, AdminGetCompanyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}',
    ...options
});

/**
 * Update company (admin)
 */
export const adminUpdateCompany = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCompanyData, ThrowOnError>) => (options.client ?? client).patch<AdminUpdateCompanyResponses, AdminUpdateCompanyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List company invites (admin)
 */
export const adminListInvites = <ThrowOnError extends boolean = false>(options: Options<AdminListInvitesData, ThrowOnError>) => (options.client ?? client).get<AdminListInvitesResponses, AdminListInvitesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}/invites',
    ...options
});

/**
 * Revoke a company invite (admin)
 */
export const adminRevokeInvite = <ThrowOnError extends boolean = false>(options: Options<AdminRevokeInviteData, ThrowOnError>) => (options.client ?? client).delete<AdminRevokeInviteResponses, AdminRevokeInviteErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}/invites/{invite_id}',
    ...options
});

/**
 * List company members (admin)
 */
export const adminListMembers = <ThrowOnError extends boolean = false>(options: Options<AdminListMembersData, ThrowOnError>) => (options.client ?? client).get<AdminListMembersResponses, AdminListMembersErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}/members',
    ...options
});

/**
 * Add member to company (admin)
 */
export const adminAddMember = <ThrowOnError extends boolean = false>(options: Options<AdminAddMemberData, ThrowOnError>) => (options.client ?? client).post<AdminAddMemberResponses, AdminAddMemberErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove member from company (admin)
 */
export const adminRemoveMember = <ThrowOnError extends boolean = false>(options: Options<AdminRemoveMemberData, ThrowOnError>) => (options.client ?? client).delete<AdminRemoveMemberResponses, AdminRemoveMemberErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/companies/{company_id}/members/{user_id}',
    ...options
});

/**
 * List all users (admin)
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Get user details (admin)
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}',
    ...options
});

/**
 * Update user (admin)
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateUserData, ThrowOnError>) => (options.client ?? client).patch<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign role to user (admin)
 */
export const adminAssignRole = <ThrowOnError extends boolean = false>(options: Options<AdminAssignRoleData, ThrowOnError>) => (options.client ?? client).post<AdminAssignRoleResponses, AdminAssignRoleErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke role from user (admin)
 */
export const adminRevokeRole = <ThrowOnError extends boolean = false>(options: Options<AdminRevokeRoleData, ThrowOnError>) => (options.client ?? client).delete<AdminRevokeRoleResponses, AdminRevokeRoleErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/roles/{role}',
    ...options
});

/**
 * Test auth endpoint (dev only)
 */
export const getAuthTest = <ThrowOnError extends boolean = false>(options?: Options<GetAuthTestData, ThrowOnError>) => (options?.client ?? client).get<GetAuthTestResponses, GetAuthTestErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/test',
    ...options
});

/**
 * Create a company invite (admin)
 */
export const createCompanyInvite = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyInviteData, ThrowOnError>) => (options.client ?? client).post<CreateCompanyInviteResponses, CreateCompanyInviteErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/companies/{company_id}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List companies for the authenticated user
 *
 * Returns the companies available in the caller's company selector. By default this is limited to active company memberships. Callers with `admin.companies.manage` instead receive all active companies.
 *
 */
export const getApiV1Companies = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CompaniesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1CompaniesResponses, GetApiV1CompaniesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/companies',
    ...options
});

/**
 * List workspaces for a company the authenticated user can access
 *
 * Returns active workspaces for the requested active company. By default the caller must belong to the company. Callers with `admin.companies.manage` may access any active company.
 *
 */
export const listCompanyWorkspaces = <ThrowOnError extends boolean = false>(options: Options<ListCompanyWorkspacesData, ThrowOnError>) => (options.client ?? client).get<ListCompanyWorkspacesResponses, ListCompanyWorkspacesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/companies/{company_id}/workspaces',
    ...options
});

/**
 * Create a workspace in a company the authenticated user can access
 *
 * Creates a workspace in the requested active company. By default the caller must belong to the company. Callers with `admin.companies.manage` may create workspaces in any active company.
 *
 */
export const createCompanyWorkspace = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyWorkspaceData, ThrowOnError>) => (options.client ?? client).post<CreateCompanyWorkspaceResponses, CreateCompanyWorkspaceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/companies/{company_id}/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteWorkspace = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkspaceData, ThrowOnError>) => (options.client ?? client).delete<DeleteWorkspaceResponses, DeleteWorkspaceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}',
    ...options
});

export const getWorkspace = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceResponses, GetWorkspaceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}',
    ...options
});

export const patchWorkspace = <ThrowOnError extends boolean = false>(options: Options<PatchWorkspaceData, ThrowOnError>) => (options.client ?? client).patch<PatchWorkspaceResponses, PatchWorkspaceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getWorkspaceContext = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceContextData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceContextResponses, GetWorkspaceContextErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/context',
    ...options
});

/**
 * Disconnect integration
 */
export const deleteWorkspaceIntegration = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkspaceIntegrationData, ThrowOnError>) => (options.client ?? client).delete<DeleteWorkspaceIntegrationResponses, DeleteWorkspaceIntegrationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}',
    ...options
});

/**
 * Get integration connection status and settings
 */
export const getWorkspaceIntegration = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceIntegrationData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceIntegrationResponses, GetWorkspaceIntegrationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}',
    ...options
});

/**
 * Update integration settings
 *
 * Updates provider-specific settings for an integration connection. Only provided fields are updated; omitted fields retain their current values.
 *
 */
export const patchWorkspaceIntegration = <ThrowOnError extends boolean = false>(options: Options<PatchWorkspaceIntegrationData, ThrowOnError>) => (options.client ?? client).patch<PatchWorkspaceIntegrationResponses, PatchWorkspaceIntegrationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync integration data and refresh the dataset
 */
export const postWorkspaceIntegrationSync = <ThrowOnError extends boolean = false>(options: Options<PostWorkspaceIntegrationSyncData, ThrowOnError>) => (options.client ?? client).post<PostWorkspaceIntegrationSyncResponses, PostWorkspaceIntegrationSyncErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}/sync',
    ...options
});

/**
 * Upload a dataset file
 */
export const uploadDataset = <ThrowOnError extends boolean = false>(options: Options<UploadDatasetData, ThrowOnError>) => (options.client ?? client).post<UploadDatasetResponses, UploadDatasetErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List datasets with filters
 */
export const listDatasets = <ThrowOnError extends boolean = false>(options: Options<ListDatasetsData, ThrowOnError>) => (options.client ?? client).get<ListDatasetsResponses, ListDatasetsErrors, ThrowOnError>({
    querySerializer: { parameters: { tags: { array: { explode: false } } } },
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets',
    ...options
});

/**
 * Delete dataset (soft)
 */
export const deleteDataset = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasetData, ThrowOnError>) => (options.client ?? client).delete<DeleteDatasetResponses, DeleteDatasetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}',
    ...options
});

/**
 * Get dataset details
 */
export const getDataset = <ThrowOnError extends boolean = false>(options: Options<GetDatasetData, ThrowOnError>) => (options.client ?? client).get<GetDatasetResponses, GetDatasetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}',
    ...options
});

/**
 * List flagged rows for a dataset
 */
export const listDatasetFlags = <ThrowOnError extends boolean = false>(options: Options<ListDatasetFlagsData, ThrowOnError>) => (options.client ?? client).get<ListDatasetFlagsResponses, ListDatasetFlagsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/flags',
    ...options
});

/**
 * List dataset rows for data review
 *
 * Returns dataset rows with exclusion metadata for the data review grid. Supports filtering to only included or only excluded rows.
 *
 */
export const listDatasetRows = <ThrowOnError extends boolean = false>(options: Options<ListDatasetRowsData, ThrowOnError>) => (options.client ?? client).get<ListDatasetRowsResponses, ListDatasetRowsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/rows',
    ...options
});

/**
 * Export dataset rows as CSV for data review
 *
 * Streams a CSV export of data review rows for the selected dataset. Supports included-only, excluded-only, or all rows.
 *
 */
export const exportDatasetRowsCsv = <ThrowOnError extends boolean = false>(options: Options<ExportDatasetRowsCsvData, ThrowOnError>) => (options.client ?? client).get<ExportDatasetRowsCsvResponses, ExportDatasetRowsCsvErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/rows/export',
    ...options
});

/**
 * Analyze dataset file
 */
export const analyzeDataset = <ThrowOnError extends boolean = false>(options: Options<AnalyzeDatasetData, ThrowOnError>) => (options.client ?? client).post<AnalyzeDatasetResponses, AnalyzeDatasetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/analyze',
    ...options
});

/**
 * Get chart for a specific dataset
 */
export const getWorkspaceDatasetChart = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceDatasetChartData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceDatasetChartResponses, GetWorkspaceDatasetChartErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/analytics/charts/{chart_type}',
    ...options
});

/**
 * Get chart for latest dataset in workspace (or specific via query)
 */
export const getWorkspaceChart = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceChartData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceChartResponses, GetWorkspaceChartErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/analytics/charts/{chart_type}',
    ...options
});

/**
 * Get ARR summary report for a dataset
 *
 * Returns ARR, retention, account, ASP, and drilldown metrics for a workspace dataset. Supports both monthly and quarterly granularity.
 *
 */
export const getWorkspaceDatasetArrSummary = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceDatasetArrSummaryData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceDatasetArrSummaryResponses, GetWorkspaceDatasetArrSummaryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/arr-summary',
    ...options
});

/**
 * Get top accounts by ARR for a dataset
 *
 * Returns the top accounts ranked by ending ARR for a given period. Includes all accounts with positive ARR at period end (active accounts), sorted by ARR descending. Use this endpoint for "who are my biggest customers" analysis, distinct from ARR movement drilldowns.
 *
 */
export const getWorkspaceDatasetTopAccounts = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceDatasetTopAccountsData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceDatasetTopAccountsResponses, GetWorkspaceDatasetTopAccountsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/top-accounts',
    ...options
});

/**
 * Get raw deal rows for an account in a dataset
 *
 * Returns the underlying rf_deals rows for a single account. Optionally filter rows to deals active during a specific reporting period.
 *
 */
export const getWorkspaceDatasetAccountDeals = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceDatasetAccountDealsData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceDatasetAccountDealsResponses, GetWorkspaceDatasetAccountDealsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/account-deals',
    ...options
});

/**
 * Get ARR trajectory for one account in a dataset
 *
 * Returns period-by-period ARR values and movement classification for a single account across a requested monthly or quarterly range.
 *
 */
export const getWorkspaceDatasetAccountPerformance = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceDatasetAccountPerformanceData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceDatasetAccountPerformanceResponses, GetWorkspaceDatasetAccountPerformanceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/account-performance',
    ...options
});

/**
 * List exclusion rules for a workspace
 *
 * Returns all active exclusion rules for the workspace. Rules are returned sorted by creation date descending (newest first).
 *
 */
export const listExclusionRules = <ThrowOnError extends boolean = false>(options: Options<ListExclusionRulesData, ThrowOnError>) => (options.client ?? client).get<ListExclusionRulesResponses, ListExclusionRulesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/exclusion-rules',
    ...options
});

/**
 * Create an exclusion rule
 *
 * Creates a workspace-scoped exclusion rule by account name. All rows matching the account name (case-insensitive, trimmed) will be excluded from ARR calculations. Returns the created rule along with the count of affected rows across all datasets.
 *
 */
export const createExclusionRule = <ThrowOnError extends boolean = false>(options: Options<CreateExclusionRuleData, ThrowOnError>) => (options.client ?? client).post<CreateExclusionRuleResponses, CreateExclusionRuleErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/exclusion-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an exclusion rule
 *
 * Removes an exclusion rule, re-including the account in ARR calculations. Takes effect immediately.
 *
 */
export const deleteExclusionRule = <ThrowOnError extends boolean = false>(options: Options<DeleteExclusionRuleData, ThrowOnError>) => (options.client ?? client).delete<DeleteExclusionRuleResponses, DeleteExclusionRuleErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/exclusion-rules/{exclusion_rule_id}',
    ...options
});

/**
 * List HubSpot deal date properties
 *
 * Returns date-compatible HubSpot deal properties (type=date or datetime) available in the connected portal for mapping start/end contract dates.
 *
 */
export const getWorkspaceIntegrationDealDateProperties = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceIntegrationDealDatePropertiesData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceIntegrationDealDatePropertiesResponses, GetWorkspaceIntegrationDealDatePropertiesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}/deal-date-properties',
    ...options
});

/**
 * List HubSpot deal pipelines
 *
 * Returns HubSpot deal pipelines and stages available in the connected portal for configuring deal stage filters.
 *
 */
export const getWorkspaceIntegrationPipelines = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceIntegrationPipelinesData, ThrowOnError>) => (options.client ?? client).get<GetWorkspaceIntegrationPipelinesResponses, GetWorkspaceIntegrationPipelinesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/integrations/{provider}/pipelines',
    ...options
});

/**
 * Validate a Plans and Actuals workbook and return a signed review
 *
 * RF-164 §6.2. Parses and validates the canonical XLSX, reads accepted state in one snapshot, and returns per-year added/changed/unchanged counts with an opaque signed receipt. Writes nothing durable. Reviews expire 30 minutes after issuance by database time. Responses carry `Cache-Control: no-store`. Returns `404 plans_actuals_disabled` when the feature is disabled for the deployment.
 *
 */
export const previewPlansActualsImport = <ThrowOnError extends boolean = false>(options: Options<PreviewPlansActualsImportData, ThrowOnError>) => (options.client ?? client).post<PreviewPlansActualsImportResponses, PreviewPlansActualsImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/imports/preview',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Accept a reviewed Plans and Actuals import or replay its saved result
 *
 * RF-164 §6.3 and §8. Resend the same file, `type`, exact `receipt` and `confirmation_id` from the preview. First acceptance returns 201; a matching completed retry returns 200 with the identical stored result. `409 review_invalid` (`details.reason` in `stale`, `expired`, `interpretation_changed`, `invalid_receipt`, `input_changed`) requires a refreshed preview and explicit confirmation. `503 acceptance_retryable` (`details.reason` in `storage_unavailable`, `transient_failure`, `outcome_unknown`) means retry the same request; `outcome_unknown` means the outcome could not be confirmed, not that the import failed. Responses carry `Cache-Control: no-store`.
 *
 */
export const confirmPlansActualsImport = <ThrowOnError extends boolean = false>(options: Options<ConfirmPlansActualsImportData, ThrowOnError>) => (options.client ?? client).post<ConfirmPlansActualsImportResponses, ConfirmPlansActualsImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/imports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List annual Plans and Actuals datasets
 *
 * RF-164 §6.4. Annual identities and metadata for the workspace, ordered by year descending, type ascending, id ascending. Pagination follows the RF-164 contract `{items, page, page_size, total}` rather than the older `total_pages` response shape. `total` is scoped to the same workspace and filters. Responses carry `Cache-Control: no-store`.
 *
 */
export const listPlansActualsDatasets = <ThrowOnError extends boolean = false>(options: Options<ListPlansActualsDatasetsData, ThrowOnError>) => (options.client ?? client).get<ListPlansActualsDatasetsResponses, ListPlansActualsDatasetsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets',
    ...options
});

/**
 * Get an annual dataset with its current monthly facts
 *
 * RF-164 §6.4. Identity, metadata, both revisions, creator and financial attribution, and a twelve-month × five-metric projection of nullable fixed-cent strings. A missing fact is `null`; a reported zero is `"0.00"`. Responses carry `Cache-Control: no-store`.
 *
 */
export const getPlansActualsDataset = <ThrowOnError extends boolean = false>(options: Options<GetPlansActualsDatasetData, ThrowOnError>) => (options.client ?? client).get<GetPlansActualsDatasetResponses, GetPlansActualsDatasetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}',
    ...options
});

/**
 * Update annual dataset source and annotation
 *
 * RF-164 §6.4. Conditional on `expected_metadata_revision`. Omitted fields remain unchanged; `null` clears. Text is trimmed and empty text becomes null. Limits are 1,000 Unicode characters for `source` and 10,000 for `annotation`. A no-op save returns the existing revision; a stale expected revision returns `409 metadata_stale`. Financial columns are never touched. Responses carry `Cache-Control: no-store`.
 *
 */
export const updatePlansActualsDatasetMetadata = <ThrowOnError extends boolean = false>(options: Options<UpdatePlansActualsDatasetMetadataData, ThrowOnError>) => (options.client ?? client).patch<UpdatePlansActualsDatasetMetadataResponses, UpdatePlansActualsDatasetMetadataErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List accepted imports that contributed to an annual dataset
 *
 * RF-164 §6.4. Distinct imports joined through imported values, including intentional unchanged-value submissions, ordered by acceptance order descending. The client derives the original download route from workspace and import IDs. Responses carry `Cache-Control: no-store`.
 *
 */
export const listPlansActualsDatasetImports = <ThrowOnError extends boolean = false>(options: Options<ListPlansActualsDatasetImportsData, ThrowOnError>) => (options.client ?? client).get<ListPlansActualsDatasetImportsResponses, ListPlansActualsDatasetImportsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/imports',
    ...options
});

/**
 * Download the retained original workbook of an accepted import
 *
 * RF-164 §6.4. Authorizes the active user and workspace, scopes the import and file, and streams the original as an attachment after verifying size and SHA-256 against immutable file metadata. Verification failure returns `503 original_unavailable`; the accepted facts remain accepted. Responses carry `Cache-Control: no-store`.
 *
 */
export const downloadPlansActualsImportOriginal = <ThrowOnError extends boolean = false>(options: Options<DownloadPlansActualsImportOriginalData, ThrowOnError>) => (options.client ?? client).get<DownloadPlansActualsImportOriginalResponses, DownloadPlansActualsImportOriginalErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/imports/{import_id}/original',
    ...options
});

/**
 * List supporting attachments of an annual dataset
 *
 * RF-168. Supporting documents retained on the dataset, oldest first, with the effective `max_file_bytes` and `max_count` limits and the `allowed_extensions` list. Attachments never change accepted financial values. Responses carry `Cache-Control: no-store`.
 *
 */
export const listPlansActualsAttachments = <ThrowOnError extends boolean = false>(options: Options<ListPlansActualsAttachmentsData, ThrowOnError>) => (options.client ?? client).get<ListPlansActualsAttachmentsResponses, ListPlansActualsAttachmentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments',
    ...options
});

/**
 * Upload a supporting attachment to an annual dataset
 *
 * RF-168. One multipart `file` part. Permitted types are `.doc`, `.docx`, `.xls`, `.xlsx`, `.ppt`, `.pptx`, `.pdf`, `.csv`, `.md`, `.png`, `.jpg` and `.jpeg`; the server derives the content type from the extension and checks the bytes. The size limit is configurable (default 25 MiB) and a dataset holds at most 10 attachments. A filename already present in the dataset, compared case-insensitively, returns `409 attachment_duplicate` with the existing attachment in `details.existing`, so a client whose earlier upload outcome was unknown can compare size and SHA-256 and treat a match as success. `503 outcome_unknown` means the outcome could not be confirmed; refresh the list. Responses carry `Cache-Control: no-store`.
 *
 */
export const uploadPlansActualsAttachment = <ThrowOnError extends boolean = false>(options: Options<UploadPlansActualsAttachmentData, ThrowOnError>) => (options.client ?? client).post<UploadPlansActualsAttachmentResponses, UploadPlansActualsAttachmentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download a supporting attachment
 *
 * RF-168. Scopes the attachment by dataset and workspace, verifies size and SHA-256 against the saved record before sending any byte, then streams it as an attachment (`Content-Disposition: attachment`, `X-Content-Type-Options: nosniff`). It is never served inline. Verification or storage failure returns `503 attachment_unavailable`. Responses carry `Cache-Control: no-store`.
 *
 */
export const downloadPlansActualsAttachment = <ThrowOnError extends boolean = false>(options: Options<DownloadPlansActualsAttachmentData, ThrowOnError>) => (options.client ?? client).get<DownloadPlansActualsAttachmentResponses, DownloadPlansActualsAttachmentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments/{attachment_id}/content',
    ...options
});

/**
 * Remove a supporting attachment
 *
 * RF-168. Deletes the record, then makes a best-effort delete of the stored object. An object-delete failure leaves an unreferenced object and the response is still `204`. There is no undelete. A retried removal returns `404`, which clients treat as success. Import originals are unreachable through this route. Responses carry `Cache-Control: no-store`.
 *
 */
export const deletePlansActualsAttachment = <ThrowOnError extends boolean = false>(options: Options<DeletePlansActualsAttachmentData, ThrowOnError>) => (options.client ?? client).delete<DeletePlansActualsAttachmentResponses, DeletePlansActualsAttachmentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments/{attachment_id}',
    ...options
});

/**
 * Export Plans and Actuals datasets to an XLSX workbook
 *
 * RF-169. One snapshot read across every requested year and both series (Plan, Actual). A requested year with no dataset for a series writes one line on that series' sheet instead of blank months. `include_metadata` (default false) repeats Created by, Created at, Last financial change by, Last financial change at, Source and Annotation on every month row of a year that has a dataset, plus a sheet note that those columns describe the year as a whole. Responses carry `Cache-Control: no-store`.
 *
 */
export const exportPlansActuals = <ThrowOnError extends boolean = false>(options: Options<ExportPlansActualsData, ThrowOnError>) => (options.client ?? client).get<ExportPlansActualsResponses, ExportPlansActualsErrors, ThrowOnError>({
    querySerializer: { parameters: { years: { array: { explode: false } } } },
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/export',
    ...options
});

/**
 * Read the Plans and Actuals report
 *
 * RF-167. One read of current facts for one workspace over an inclusive month window. `workspace_id`, `granularity`, `start`, and `end` match the ARR summary parameters. The server always returns Plan, Actual, and Compare. It returns one period per month or quarter in the window, oldest first. It rolls up first, then subtracts. It does not subtract months and then roll those differences. The client sends the parameters and displays the payload. It does not roll up periods or compute compare. Metric-card trends are a client display concern and are not on this response. A month is never partial. A quarter is partial for every metric when at least one month has an amount and at least one month does not. `partial` is false when all three months are present and when none are present. Revenue and EBITDA quarters sum all three months when every month is present, including an explicit zero. A partial Revenue or EBITDA amount is the sum of the months that are present. Cash, Debt and ARR quarters use the latest month that has an amount. A complete quarter uses the quarter-end month (March, June, September, December), including an explicit zero. A partial quarter uses the latest month that has an amount, including an explicit zero. No month is null. Compare is Actuals minus Plan after each side is rolled up. `compare.amount` is null when Plan or Actuals has no amount. When both amounts exist, the difference is formed. If Plan or Actuals is partial, `compare.partial` is true and `compare.amount` is that difference. If neither side is partial, `compare.partial` is false and `compare.amount` is that difference. Amounts are JSON numbers in USD dollars. Null means no amount. A window with no facts is HTTP 200 with null amounts. Responses carry `Cache-Control: no-store`. A quarterly cent sum or a compare difference past the amount magnitude cap is an error. The read does not clamp or wrap.
 *
 */
export const getPlansActualsReport = <ThrowOnError extends boolean = false>(options: Options<GetPlansActualsReportData, ThrowOnError>) => (options.client ?? client).get<GetPlansActualsReportResponses, GetPlansActualsReportErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-rf_session',
            type: 'apiKey'
        }],
    url: '/api/v1/workspaces/{workspace_id}/plans-actuals/report',
    ...options
});
